import axios from 'axios'
import { config } from '../assets/config/config'

const apiUrl = config.api.url

/**
 * Redeem a code for credits or special features
 * @param {string} code - The redemption code (must start with RH and be at least 10 characters)
 * @returns {Promise} - Promise resolving to the redemption response
 */
const redeemCode = (code) => {
  return axios.post(`${apiUrl}/v1/redemption-codes/redeem`, {
    code: code.trim().toUpperCase() // Normalize the code
  })
}

/**
 * Validate a redemption code without redeeming it
 * @param {string} code - The redemption code to validate
 * @returns {Promise} - Promise resolving to validation response
 */
const validateCode = (code) => {
  return axios.post(`${apiUrl}/v1/redemption-codes/validate`, {
    code: code.trim().toUpperCase()
  })
}

/**
 * Get user's redemption history
 * @param {string} userId - The user's ID
 * @returns {Promise} - Promise resolving to list of redeemed codes
 */
const getRedemptionHistory = (userId) => {
  return axios.get(`${apiUrl}/v1/users/${userId}/redemption-history`)
}

export const redemptionCodeService = {
  redeemCode,
  validateCode,
  getRedemptionHistory,
}
